// Where pasted spreadsheet text lands in the Watchlist grid, following Excel:
// - one copied value pasted onto a multi-cell selection fills every cell;
// - otherwise the block is placed from the selection's top-left cell, going
//   down the visible rows (current sort and filter) and right across the
//   visible columns.
// Cells that are not editable are skipped but still take their place in the
// block, so values never shift sideways or upwards into the wrong security.

import { categoryDisplay } from './categoryTools';

/**
 * `block`: string[][] from parseTsv. `selection`: inclusive display-index
 * bounds { minRowIndex, maxRowIndex, minColumnIndex, maxColumnIndex }.
 * Returns cell writes for editable cells only, plus how many pasted values
 * fell outside the grid.
 */
export function planPaste({ rowIds, columnIds, selection, block, isEditable }) {
    const changes = [];
    if (!block.length || !rowIds.length || !columnIds.length) {
        return { changes, clippedCount: 0 };
    }
    const single = block.length === 1 && block[0].length === 1;
    const selectionIsRange = selection.maxRowIndex > selection.minRowIndex
        || selection.maxColumnIndex > selection.minColumnIndex;

    if (single && selectionIsRange) {
        const value = categoryDisplay(block[0][0]);
        for (let rowIndex = selection.minRowIndex; rowIndex <= selection.maxRowIndex; rowIndex += 1) {
            for (let columnIndex = selection.minColumnIndex; columnIndex <= selection.maxColumnIndex; columnIndex += 1) {
                const rowId = rowIds[rowIndex];
                const columnId = columnIds[columnIndex];
                if (rowId != null && columnId != null && isEditable(rowId, columnId)) {
                    changes.push({ rowId, columnId, value });
                }
            }
        }
        return { changes, clippedCount: 0 };
    }

    let clippedCount = 0;
    block.forEach((cells, rowOffset) => {
        cells.forEach((cell, columnOffset) => {
            const rowId = rowIds[selection.minRowIndex + rowOffset];
            const columnId = columnIds[selection.minColumnIndex + columnOffset];
            if (rowId == null || columnId == null) {
                clippedCount += 1;
                return;
            }
            if (isEditable(rowId, columnId)) {
                changes.push({ rowId, columnId, value: categoryDisplay(cell) });
            }
        });
    });
    return { changes, clippedCount };
}
